import { Col, Row } from "react-bootstrap";

import ContactData from "../../data/contact.json"
import React from "react";

export const Cookie = () => {

	const rowStyle = {
		color: 'white',
		backgroundColor: 'black',
		padding: '5vh 10vw  20vh  10vw',
	};

	return (
		<Row style={rowStyle}>
			<Col md={12} className="">
			<h2 className="text-center"><strong >Informativa sulla gestione dei Cookie</strong></h2><br /><br />
				<p>
					In conformità con il Regolamento Generale sulla Protezione dei Dati (RGPD) dell'Unione Europea e le leggi nazionali italiane sulla protezione dei dati personali, la presente Informativa sui Cookie riguarda l'uso dei cookie sul nostro sito web, accessibile all'indirizzo {ContactData.siteAdress}.
				</p>
				<p>
					<strong >Cookie</strong><br />
					Un cookie è un piccolo file di testo inviato da alcuni servizi web e memorizzato sul tuo dispositivo (computer, smartphone, tablet) mentre navighi su Internet. Tuttavia, desideriamo precisare che il nostro sito web non utilizza cookie. Non raccogliamo informazioni personali tramite cookie né utilizziamo tecnologie di tracciamento simili.
				</p>
				<p>
					<strong >Finalità del Trattamento</strong><br />
					Poiché non utilizziamo cookie, non raccogliamo dati personali tramite questa tecnologia. Non raccogliamo né condividiamo alcuna informazione personale sugli utenti del nostro sito tramite cookie.
				</p>
				<p>
					<strong >Gestione dei Cookie</strong><br />
					Poiché non utilizziamo cookie, non c'è alcuna necessità di gestirli o di fornire opzioni di consenso per il loro utilizzo sul nostro sito.
				</p>
				<p>
					<strong >Diritti dell'Interessato</strong><br />
					In base alle leggi vigenti, hai il diritto di richiedere informazioni sulla gestione dei cookie da parte del nostro sito. Per esercitare questi diritti o per porre domande sulla nostra politica di gestione dei cookie, puoi contattarci utilizzando i dati di contatto riportati di seguito.
				</p>
				<p>
					<strong >Contatti</strong><br />
					{ContactData.name}<br /><span dangerouslySetInnerHTML={{ __html: ContactData.adressMain }} /><br />P.Iva: {ContactData.vat}<br />Email: <a href={`mailto:${ContactData.emailAddress}`} style={{color:'white'}}>{ContactData.emailAddress}</a>
				</p>
				<p>
					<strong >Aggiornamenti</strong><br />
					Questa Informativa sulla gestione dei cookie è soggetta a modifiche e aggiornamenti. Ti consigliamo di verificarla periodicamente per rimanere informato sulle nostre pratiche.
					<br />
					Ultimo aggiornamento: 30 ottobre 2023
				</p>

			</Col>
		</Row>
	);
};
